// extracted by mini-css-extract-plugin
module.exports =  {"features":"a10a3f92e9--features--sfe3h","item":"a10a3f92e9--item--vYtGr","bg_gray6_100":"a10a3f92e9--bg_gray6_100--eWIcm","bg_gray10_100":"a10a3f92e9--bg_gray10_100--L1tNm"};